import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICompanyModel } from '@apps-common/types/portal/company'

export const QUERY_KEY_PORTAL_GET_COMPANY = 'getCompany'

export const getCompany = async (): Promise<ICompanyModel> => axios.get('/me/GetMyCompany').then((res) => res.data?.data)

type QueryFnType = typeof getCompany

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetCompany = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: [QUERY_KEY_PORTAL_GET_COMPANY],
    queryFn: () => getCompany()
  })
